// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Dashboard metrics grow with their content instead of using fixed heights. */
.dashboard-page .dashboard-welcome h2 {
  font-size: 24px;
  font-weight: 600;
  color: #174078;
  margin: 0 0 24px;
}
.dashboard-page .stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(0, 1.6fr);
  gap: 20px;
  margin-bottom: 24px;
}
.dashboard-page .stat-card,
.dashboard-page .shop4me-card {
  height: auto;
  min-height: 0;
  min-width: 0;
  padding: clamp(16px, 2vw, 24px);
  border: none;
  border-radius: 16px;
  box-sizing: border-box;
}
.dashboard-page .card-blue,
.dashboard-page .shop4me-card {
  background: #f0f6ff;
}
.dashboard-page .card-orange {
  background: #fff4ec;
}
.dashboard-page .stat-card:not(.transaction-card) {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-content: start;
  align-items: center;
  gap: 20px 8px;
}
.dashboard-page .card-icon-bg {
  position: static;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  flex-shrink: 0;
}
.dashboard-page .card-icon-bg img {
  width: 22px;
  height: 22px;
}
.dashboard-page .stat-card:not(.transaction-card) .card-icon-bg {
  justify-self: end;
}
.dashboard-page .percentage-badge {
  position: static;
  justify-self: start;
  max-width: 100%;
  box-sizing: border-box;
  padding: 4px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  overflow-wrap: anywhere;
}
.dashboard-page .card-blue .percentage-badge {
  background: #e3fff7;
  color: #008763;
}
.dashboard-page .card-orange .percentage-badge {
  background: #ffe7e7;
  color: #c92d30;
}
.dashboard-page .card-text-content {
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}
.dashboard-page .card-title {
  position: static;
  transform: none;
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
}
.dashboard-page .card-value-row {
  position: static;
  display: flex;
  min-width: 0;
}
.dashboard-page .card-value {
  position: static;
  margin: 0;
  font-size: clamp(28px, 2.6vw, 40px);
  font-weight: 700;
  line-height: 1.2;
  overflow-wrap: anywhere;
}
.dashboard-page .card-blue .card-title,
.dashboard-page .card-blue .card-value,
.dashboard-page .shop4me-card .card-title,
.dashboard-page .shop4me-card .card-value {
  color: #174078;
}
.dashboard-page .card-orange .card-title,
.dashboard-page .card-orange .card-value {
  color: #e85e00;
}
.dashboard-page .stat-card.transaction-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: flex-start;
}
.dashboard-page .transaction-card-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}
.dashboard-page .transaction-card-header .card-icon-bg {
  background: #ffeadd;
}
.dashboard-page .transaction-card .card-value {
  font-size: clamp(24px, 2.2vw, 34px);
}
.dashboard-page .currency-toggle {
  display: inline-flex;
  padding: 3px;
  border: 1px solid #fdba74;
  border-radius: 100px;
  background: #fff;
}
.dashboard-page .currency-toggle button {
  min-height: 32px;
  padding: 6px 10px;
  border: none;
  border-radius: 100px;
  background: transparent;
  color: #c65200;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
}
.dashboard-page .currency-toggle button.active {
  background: #fff3ea;
}
/* --- Main Content Grid --- */
.dashboard-page .main-content-grid {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 24px;
}

/* --- Recent Shipment Transaction Card --- */
.dashboard-page .recent-transactions-card {
  background-color: #ffffff;
  border: 1px solid #f3f4f6;
  border-radius: 16px;
  padding: 25px;
}
.dashboard-page .card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.dashboard-page .card-header h4 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #111827;
}
.dashboard-page .see-all-link {
  color: #f97316;
  font-weight: 600;
  text-decoration: none;
}
.dashboard-page .transactions-tabs {
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 10px;
}
.dashboard-page .transactions-tabs button {
  background: none;
  border: none;
  padding: 0 4px 12px 4px;
  margin-right: 25px;
  font-size: 16px;
  color: #6b7280;
  cursor: pointer;
  position: relative;
  border-bottom: 2px solid transparent;
}
.dashboard-page .transactions-tabs button.active {
  color: #f97316;
  font-weight: 600;
  border-bottom-color: #f97316;
}
.dashboard-page .transactions-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.dashboard-page .transactions-list li {
  display: flex;
  align-items: center;
  padding: 20px 0;
  border-bottom: 1px solid #f3f4f6;
}
.dashboard-page .transactions-list li:last-child {
  border-bottom: none;
}
.dashboard-page .tx-status-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 16px;
  flex-shrink: 0;
}
.dashboard-page .tx-status-icon img {
  width: 24px;
  height: 24px;
  filter: none;
}
.dashboard-page .tx-status-icon.pending {
  background-color: #fffbeb;
}
.dashboard-page .tx-status-icon.completed {
  background-color: #f0fdf4;
}
.dashboard-page .tx-status-icon.failed {
  background-color: #fef2f4;
}
.dashboard-page .tx-details {
  flex-grow: 1;
}
.dashboard-page .tx-description {
  font-weight: 500;
  font-size: 16px;
  color: #111827;
  margin: 0 0 4px 0;
}
.dashboard-page .tx-id {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
}
.dashboard-page .tx-info {
  text-align: right;
  color: #6b7280;
}
.dashboard-page .tx-date {
  font-size: 14px;
  margin: 0 0 4px 0;
}
.dashboard-page .tx-time {
  font-size: 12px;
  margin: 0;
}
.dashboard-page .tx-amount {
  font-size: 18px;
  font-weight: 600;
  color: #1e3a8a;
  margin-left: auto;
  padding-left: 24px;
  min-width: 120px;
  text-align: right;
}

.dashboard-page .shop4me-card {
  display: flex;
  flex-direction: column;
  align-self: start;
  gap: 16px;
}
.dashboard-page .shop4me-card .card-icon-bg {
  align-self: flex-end;
}
.dashboard-page .main-content-grid {
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
}
.dashboard-page .main-content-grid > * {
  min-width: 0;
}
@media (max-width: 1200px) {
  .dashboard-page .stats-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-page .main-content-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 600px) {
  .dashboard-page .stats-grid {
    grid-template-columns: minmax(0, 1fr);
    gap: 12px;
  }
  .dashboard-page .stat-card:not(.transaction-card) {
    gap: 12px;
  }
  .dashboard-page .card-text-content {
    gap: 8px;
  }
  .dashboard-page .card-value {
    font-size: 30px;
  }
  .dashboard-page .recent-transactions-card {
    padding: 16px;
  }
  .dashboard-page .transactions-list li {
    flex-wrap: wrap;
    gap: 12px;
  }
  .dashboard-page .tx-details {
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .dashboard-page .tx-amount {
    min-width: 0;
    padding-left: 0;
    overflow-wrap: anywhere;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA,8EAA8E;AAC9E;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iEAAiE;EACjE,SAAS;EACT,mBAAmB;AACrB;AACA;;EAEE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,+BAA+B;EAC/B,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;;;;EAIE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA,8BAA8B;AAC9B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA,6CAA6C;AAC7C;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,SAAS;AACX;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,oBAAoB;AACtB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,YAAY;AACd;AACA;EACE;IACE,gDAAgD;EAClD;EACA;IACE,qCAAqC;EACvC;AACF;AACA;EACE;IACE,qCAAqC;IACrC,SAAS;EACX;EACA;IACE,SAAS;EACX;EACA;IACE,QAAQ;EACV;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,eAAe;IACf,SAAS;EACX;EACA;IACE,YAAY;IACZ,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,eAAe;IACf,uBAAuB;EACzB;AACF","sourcesContent":["/* Dashboard metrics grow with their content instead of using fixed heights. */\n.dashboard-page .dashboard-welcome h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #174078;\n  margin: 0 0 24px;\n}\n.dashboard-page .stats-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr)) minmax(0, 1.6fr);\n  gap: 20px;\n  margin-bottom: 24px;\n}\n.dashboard-page .stat-card,\n.dashboard-page .shop4me-card {\n  height: auto;\n  min-height: 0;\n  min-width: 0;\n  padding: clamp(16px, 2vw, 24px);\n  border: none;\n  border-radius: 16px;\n  box-sizing: border-box;\n}\n.dashboard-page .card-blue,\n.dashboard-page .shop4me-card {\n  background: #f0f6ff;\n}\n.dashboard-page .card-orange {\n  background: #fff4ec;\n}\n.dashboard-page .stat-card:not(.transaction-card) {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-content: start;\n  align-items: center;\n  gap: 20px 8px;\n}\n.dashboard-page .card-icon-bg {\n  position: static;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #fff;\n  flex-shrink: 0;\n}\n.dashboard-page .card-icon-bg img {\n  width: 22px;\n  height: 22px;\n}\n.dashboard-page .stat-card:not(.transaction-card) .card-icon-bg {\n  justify-self: end;\n}\n.dashboard-page .percentage-badge {\n  position: static;\n  justify-self: start;\n  max-width: 100%;\n  box-sizing: border-box;\n  padding: 4px 8px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  overflow-wrap: anywhere;\n}\n.dashboard-page .card-blue .percentage-badge {\n  background: #e3fff7;\n  color: #008763;\n}\n.dashboard-page .card-orange .percentage-badge {\n  background: #ffe7e7;\n  color: #c92d30;\n}\n.dashboard-page .card-text-content {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n.dashboard-page .card-title {\n  position: static;\n  transform: none;\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n.dashboard-page .card-value-row {\n  position: static;\n  display: flex;\n  min-width: 0;\n}\n.dashboard-page .card-value {\n  position: static;\n  margin: 0;\n  font-size: clamp(28px, 2.6vw, 40px);\n  font-weight: 700;\n  line-height: 1.2;\n  overflow-wrap: anywhere;\n}\n.dashboard-page .card-blue .card-title,\n.dashboard-page .card-blue .card-value,\n.dashboard-page .shop4me-card .card-title,\n.dashboard-page .shop4me-card .card-value {\n  color: #174078;\n}\n.dashboard-page .card-orange .card-title,\n.dashboard-page .card-orange .card-value {\n  color: #e85e00;\n}\n.dashboard-page .stat-card.transaction-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  justify-content: flex-start;\n}\n.dashboard-page .transaction-card-header {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n.dashboard-page .transaction-card-header .card-icon-bg {\n  background: #ffeadd;\n}\n.dashboard-page .transaction-card .card-value {\n  font-size: clamp(24px, 2.2vw, 34px);\n}\n.dashboard-page .currency-toggle {\n  display: inline-flex;\n  padding: 3px;\n  border: 1px solid #fdba74;\n  border-radius: 100px;\n  background: #fff;\n}\n.dashboard-page .currency-toggle button {\n  min-height: 32px;\n  padding: 6px 10px;\n  border: none;\n  border-radius: 100px;\n  background: transparent;\n  color: #c65200;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n}\n.dashboard-page .currency-toggle button.active {\n  background: #fff3ea;\n}\n/* --- Main Content Grid --- */\n.dashboard-page .main-content-grid {\n  display: grid;\n  grid-template-columns: 2fr 1fr;\n  gap: 24px;\n}\n\n/* --- Recent Shipment Transaction Card --- */\n.dashboard-page .recent-transactions-card {\n  background-color: #ffffff;\n  border: 1px solid #f3f4f6;\n  border-radius: 16px;\n  padding: 25px;\n}\n.dashboard-page .card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.dashboard-page .card-header h4 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: #111827;\n}\n.dashboard-page .see-all-link {\n  color: #f97316;\n  font-weight: 600;\n  text-decoration: none;\n}\n.dashboard-page .transactions-tabs {\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 10px;\n}\n.dashboard-page .transactions-tabs button {\n  background: none;\n  border: none;\n  padding: 0 4px 12px 4px;\n  margin-right: 25px;\n  font-size: 16px;\n  color: #6b7280;\n  cursor: pointer;\n  position: relative;\n  border-bottom: 2px solid transparent;\n}\n.dashboard-page .transactions-tabs button.active {\n  color: #f97316;\n  font-weight: 600;\n  border-bottom-color: #f97316;\n}\n.dashboard-page .transactions-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n.dashboard-page .transactions-list li {\n  display: flex;\n  align-items: center;\n  padding: 20px 0;\n  border-bottom: 1px solid #f3f4f6;\n}\n.dashboard-page .transactions-list li:last-child {\n  border-bottom: none;\n}\n.dashboard-page .tx-status-icon {\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 16px;\n  flex-shrink: 0;\n}\n.dashboard-page .tx-status-icon img {\n  width: 24px;\n  height: 24px;\n  filter: none;\n}\n.dashboard-page .tx-status-icon.pending {\n  background-color: #fffbeb;\n}\n.dashboard-page .tx-status-icon.completed {\n  background-color: #f0fdf4;\n}\n.dashboard-page .tx-status-icon.failed {\n  background-color: #fef2f4;\n}\n.dashboard-page .tx-details {\n  flex-grow: 1;\n}\n.dashboard-page .tx-description {\n  font-weight: 500;\n  font-size: 16px;\n  color: #111827;\n  margin: 0 0 4px 0;\n}\n.dashboard-page .tx-id {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n}\n.dashboard-page .tx-info {\n  text-align: right;\n  color: #6b7280;\n}\n.dashboard-page .tx-date {\n  font-size: 14px;\n  margin: 0 0 4px 0;\n}\n.dashboard-page .tx-time {\n  font-size: 12px;\n  margin: 0;\n}\n.dashboard-page .tx-amount {\n  font-size: 18px;\n  font-weight: 600;\n  color: #1e3a8a;\n  margin-left: auto;\n  padding-left: 24px;\n  min-width: 120px;\n  text-align: right;\n}\n\n.dashboard-page .shop4me-card {\n  display: flex;\n  flex-direction: column;\n  align-self: start;\n  gap: 16px;\n}\n.dashboard-page .shop4me-card .card-icon-bg {\n  align-self: flex-end;\n}\n.dashboard-page .main-content-grid {\n  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);\n}\n.dashboard-page .main-content-grid > * {\n  min-width: 0;\n}\n@media (max-width: 1200px) {\n  .dashboard-page .stats-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n  .dashboard-page .main-content-grid {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n@media (max-width: 600px) {\n  .dashboard-page .stats-grid {\n    grid-template-columns: minmax(0, 1fr);\n    gap: 12px;\n  }\n  .dashboard-page .stat-card:not(.transaction-card) {\n    gap: 12px;\n  }\n  .dashboard-page .card-text-content {\n    gap: 8px;\n  }\n  .dashboard-page .card-value {\n    font-size: 30px;\n  }\n  .dashboard-page .recent-transactions-card {\n    padding: 16px;\n  }\n  .dashboard-page .transactions-list li {\n    flex-wrap: wrap;\n    gap: 12px;\n  }\n  .dashboard-page .tx-details {\n    min-width: 0;\n    overflow-wrap: anywhere;\n  }\n  .dashboard-page .tx-amount {\n    min-width: 0;\n    padding-left: 0;\n    overflow-wrap: anywhere;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
